import { defineStore } from "pinia"
import baseAPI from "@/stores/base-api"

export const useAuthStore = defineStore("auth", {
  state: () => ({
    errMsg: "",
    userInfo: null,
    token: localStorage.getItem('user-token'),
    permissions: ['all', 'noauth'],
    account: null,
    account_list: [],
    notice_unread: 0,
    paymentData: null, // 1
  }),
  actions: {
    async loginHandler(email, password) {
      await baseAPI().post("/profiles/login", { login: email, password: password})
        .then((data) => {
          this.errMsg = '';
          this.token = data.data.token;
          localStorage.setItem('user-token', this.token); // store the token in localstorage
        })
        .catch((error) => {
          this.errMsg = 'Не верные телефон или пароль';
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.errMsg = error.response.data.Exception.message;
          }
          this.userLogOut();
        })
        await this.getCurrentUser(true);
        if (!this.isAuthenticated) {
          if (!this.errMsg) {
            this.errMsg = 'Не удалось выполнить вход в ЛК. Попробуйте позднее.';
          }
        }
    },
    async getCurrentUser(updateInfo = false) {

      if (!this.token) return true;
      if (!this.userInfo) { updateInfo = true; }
      if (!updateInfo) return true;

      await baseAPI().get("/profiles/profile")
        .then((data) => {
          this.userInfo = data.data;
        })
        .catch((error) => {
          this.userLogOut();
          return false;
        }
      );

      this.permissions = ['all', 'auth'];
      this.account = null;
      this.account_list = [];
      this.notice_unread = 0;

      await baseAPI().get("/commons/permission")
        .then((data) => {
          for (let item of data.data) {
            this.permissions.push(item.code);
          }
        })
        .catch((error) => {
          return false;
        }
      );

      await baseAPI().get("/accounts/view")
        .then((data) => {
          this.account = data.data;
        })
        .catch((error) => {
          return false;
        }
      );
      
      await baseAPI().get("/accounts/list")
        .then((data) => {
          this.account_list = data.data;
        })
        .catch((error) => {
          return false;
        }
      );
      
      await baseAPI().get("/notices/unreaded")
        .then((data) => {
          this.notice_unread = data.data.count;
        })
        .catch((error) => {
          return false;
        }
      );
    },
    async updateNotice() {
      await baseAPI().get("/notices/unreaded")
        .then((data) => {
          this.notice_unread = data.data.count;
        })
        .catch((error) => {
        }
      );
    },
    userLogOut() {
      this.token = null;  
      localStorage.removeItem('user-token') // clear your user's token from localstorage
      this.userInfo = null;
      this.permissions = ['all', 'noauth'];
      this.account = null;
      this.account_list = [];
    },
    setToken(token) {
      this.token = token;
      localStorage.setItem('user-token', this.token)
    },
    // Метод для сохранения данных платежа
    setPaymentData(paymentData) {
      this.paymentData = paymentData;
    },
    
    // Метод для получения данных платежа
    getPaymentData() {
      return this.paymentData;
    },

    // Метод для очистки данных платежа
    clearPaymentData() {
      this.paymentData = null;
    },
  },
  getters: {
    isAuthenticated: state => !!state.token,
    accountCount(state) {
      return state.account_list.length;
    }
  }
});
